/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestNoteTakingApps from "views/articles/BestNoteTakingApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"

const AddAppollowToYourHomeScreenEN = ({ apps }: { apps: AppInterface[] }) => {
  const article = BestNoteTakingApps["en"]
  return (
    <InstantArticle {...article}>
      <div style={{ textAlign: "justify" }}>
        <p>
          To help you take better notes and create streamlined to-do lists,
          we&apos;ve rounded up the best note-taking apps for iPad based on
          pricing, reviews, features, and compatibility so you can write your
          notes like a pro.
        </p>
        <h2>Noteability </h2>
        <p>
          Notability is a premium notes app that offers a simple interface and
          powerful capabilities. Users can add multimedia elements such as audio
          and video to their notes, and the app includes various formatting
          tools. It combines several different types of note-taking apps and
          offers features such as journal creation, ink tools, and highlighters.
          However, the app requires a paid Plus membership subscription, and
          document sizes are limited.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 360593530)} />
        </div>
        <h2>Microsoft OneNote</h2>
        <p>
          Microsoft OneNote is a free notes app. Notes are organized by
          notebooks, sections, and pages, with the ability to create
          sub-notebooks and sub-pages. Users can add text, files, draw, change
          paper styles, and record audio. The app also provides a
          pressure-sensitive pen tool and highlighter that can be customized
          with different colors, including glitter options. In addition, users
          can save an unlimited number of favorite pens and markers in the
          toolbar.
        </p>

        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 410395246)} />
        </div>
        <h2>CollaNote</h2>
        <p>
          CollaNote is a free note-taking app that offers a wide range of
          functionality. It comes with a classic pen, pencil, highlighter, lasso
          and eraser tools, and users can customize colors and save their
          favorite color combinations and thicknesses. The app also includes a
          laser pointer, adjustable ruler, stickers, voice notes, templates for
          paper types, and a digital journal. One of its biggest advantages is
          the collaboration feature, allowing notes to be collaborated with
          others and to merge everyone&apos;s notes. However, the text tool is
          not easy to use, as it requires a separate screen to write or write
          text.
        </p>

        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1540956268)} />
        </div>
        <h2>Notebook by Zoho</h2>
        <p>
          Notebook is an application that allows users to combine written notes
          with hand-drawn diagrams or handwritten notes. The app offers full
          customization of pencil, pen and highlighter colors. It also has
          features like locking specific notes and scanning documents to
          annotate directly. However, the downside to Notebook is that
          handwritten notes are kept separate from other types of notes, making
          it less useful for those who like to mix different types of notes on
          the same page.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 973801089)} />
        </div>
        <h2>Apple Notes</h2>
        <p>
          Apple&apos;s default Notes app is a handy note-taking app that comes
          with basic tools like pen, highlighter, pencil, eraser, lasso tool,
          and an adjustable ruler. There are also different paper styles and the
          ability to scan documents using the phone&apos;s camera. Scanned
          documents are kept as attachments and cannot be marked with the pen.
          The app also allows for syncing across multiple devices and
          handwriting with the Apple Pencil.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1110145109)} />
        </div>
        <div className="card mt-4">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              Do you have any favorite apps or tools that you use with your
              iPad? You can submit your favorite apps through Appollow&apos;s{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  submit page
                </span>
              </Link>
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenEN
